var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-white font-weight-bold"},[_c('div',{staticClass:"font-size-21 mb-2"},[_vm._v("Lifetime Sales")]),_c('div',{staticClass:"d-flex align-items-end flex-wrap"},[_c('div',{staticClass:"pr-3 mr-auto"},[_c('i',{staticClass:"fe fe-server font-size-48"})]),_c('div',{staticClass:"font-size-36 mb-n2"},[_vm._v("$16,942.09")])])])
}]

export { render, staticRenderFns }